import { Banner } from '@/components/banner/banner.comp';
import { DiscoverHero } from '@/components/discoverHero/discoverHero.comp';
import { Layout } from '@/components/layout/layout.comp';
import { MoreApps } from '@/components/moreApps/moreApps.comp';
import { Platforms } from '@/components/platforms/platforms.comp';
import { WidgetCatalog } from '@/components/widgetCatalog/widgetCatalog.comp';
import { getDataFromDB } from '@/lib/mongodb';
import { getRandomApps } from '@/lib/search';
import clientPromise, {
	getSearchEngineDataDB,
} from '@/lib/searchEngineMongodb';
import { IPlatform, IPlugin, THit } from '@/types';
import Script from 'next/script';

export default function Home({
	apps,
	platforms,
	totalApps,
	moreApps,
}: {
	apps: IPlugin[];
	platforms: IPlatform[];
	totalApps: number;
	moreApps: THit[];
}) {
	return (
		<Layout
			showFooter={true}
			showHeader={true}
			url={`https://discover.commoninja.com/`}
		>
			{loadScripts()}
			<DiscoverHero platforms={platforms} totalApps={totalApps} />
			<Platforms />
			<WidgetCatalog apps={apps} />
			<MoreApps appSynonym="app" hits={moreApps} />
			<Banner />
		</Layout>
	);
}

export async function getStaticProps() {
	const platforms = await getSearchEngineDataDB<IPlatform>(
		'platforms',
		{},
		{
			displayName: 1,
			name: 1,
		}
	);

	const client = await clientPromise;
	const db = client.db('searchengine_db');
	const totalApps = await db.collection('platformapps').countDocuments();
	const apps = await getDataFromDB<IPlugin>('apps', {
		status: 'published',
	});
	const randomApps = apps.sort(() => 0.5 - Math.random()).splice(0, 12);
	const moreApps = await getRandomApps({ limit: 10 });

	return {
		props: { apps: randomApps, platforms, totalApps: totalApps || 0, moreApps },
	};
}

function loadScripts() {
	return (
		<>
			<Script id="discover-script" type="application/ld+json">{`
        {
          "@context": "https://schema.org/",
          "@type": "WebSite",
          "name": "Find the best apps for your website | Common Ninja",
          "url": "https://discover.commoninja.com/",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://discover.commoninja.com/results?q={search_term_string}&orderBy=popular",
            "query-input": "required name=search_term_string"
          }
        }
        `}</Script>
		</>
	);
}
